import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as beaconsApi from '../../api/beacons';
const initialState = {
    feed: [],
    dateFilter: 'today',
    myBeacons: [],
    loading: false,
};
export const fetchFeed = createAsyncThunk('beacons/fetchFeed', async ({ date, from, cityId }) => {
    return beaconsApi.getFeed({ date, from, cityId });
});
export const fetchMyBeacons = createAsyncThunk('beacons/fetchMyBeacons', async () => {
    return beaconsApi.getMyBeacons();
});
const beaconsSlice = createSlice({
    name: 'beacons',
    initialState,
    reducers: {
        setDateFilter(state, action) {
            state.dateFilter = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFeed.pending, (state) => {
            state.loading = true;
        })
            .addCase(fetchFeed.fulfilled, (state, action) => {
            state.loading = false;
            state.feed = action.payload;
        })
            .addCase(fetchFeed.rejected, (state) => {
            state.loading = false;
        })
            .addCase(fetchMyBeacons.fulfilled, (state, action) => {
            state.myBeacons = action.payload;
        });
    },
});
export const { setDateFilter } = beaconsSlice.actions;
export default beaconsSlice.reducer;
